
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l809c_1r3w6_6"
};
  